import DateConvert from "../Utlis/DateConverter";
import '../CSS/HomeCard.css';
import { Link } from "react-router-dom";
function HomeCard({Postdata,title}){
    return(
        <div className="HomecardWrapper">
        <h1 className="BoxHeading">{title}</h1>
        <div className="HomeSectionTitle">
          {Postdata.slice(-3).map((post, index) => (
            <div className="BoxModel" key={index}>
      <Link to={`/blogpage/${post._id}`} className="HomecardTitletag">
        <div className="Homecard">
          <div className="HomecardImageWrap">
            <img
              className="HomeImageTag"
              src={post.thumbnailUrl}
              alt="Logo"
            />
          </div>
          <div className="HomecardContentWrap">
            <h4 className="HomecardTitle">{post.title}</h4>
            <p className="HomecardContent">
              {post.content}
            </p>
            <div className="HomecardFooter">
              <p className="ProfileNameTag">{post.author} | {DateConvert(post.createdAt)} | {post.Sector}</p>
            </div>
          </div>
        </div>
      </Link>
    </div>
          ))}
          {Postdata.length > 3 && (
            <div className="BoxModel">
              <div className="Homecard ReadMoreCard">
                <Link to='/News' className="ReadMoreLink">
                  <h2>Read More</h2>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    )
}

export default HomeCard;